<template>
  <div id="documentDeveloperContainer" class="page-container">
    <div class="page-content">
      <div class="flex-row-center mt-16">
        <span class="page-title">
          Documentation
          <span class="fc-6C30CC">for dev</span>
        </span>
        <span class="page-des ml-16"
          >If your code doesn't work. let's change noting and run it
          again.</span
        >
      </div>
      <el-tabs class="style-bar" v-model="activeName">
        <el-tab-pane name="update">
          <span slot="label" class="title-bar">Update</span>
          <update></update>
        </el-tab-pane>
        <el-tab-pane name="documents">
          <span slot="label" class="title-bar">Documents</span>
          <documents></documents>
        </el-tab-pane>
        <el-tab-pane name="icons">
          <span slot="label" class="title-bar">Icons</span>
          <icons></icons>
        </el-tab-pane>
        <el-tab-pane name="logo">
          <span slot="label" class="title-bar">Logo</span>
          <logo></logo>
        </el-tab-pane>
        <el-tab-pane name="testing">
          <span slot="label" class="title-bar">Testing</span>
          <testing></testing>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  name: "document-developer",
  components: {
    icons: require("./document-developer/icons").default,
    logo: require("./document-developer/logo").default,
    update: require("./document-developer/update").default,
    testing: require("./document-developer/testing").default,
    documents: require("./document-developer/documents").default,
  },
  data() {
    return {
      activeName: "update",
      anchor: {
        update: "update",
        documents: "documents",
        icons: "icons",
        logo: "logo",
        testing: "testing",
      },
    };
  },
  watch: {
    activeName() {
      if (this.activeName != "") {
        const tab = this.activeName || "";
        const paramsTab = this.$router.currentRoute.params.tab;
        if (paramsTab != tab) {
          this.$router.push({ name: "document-developer", params: { tab } });
        }
      }
    },
  },
  mounted() {
    const paramsTab = this.$router.currentRoute.params.tab;
    if (paramsTab && this.anchor[paramsTab]) {
      this.activeName = paramsTab;
    } else {
      const tab = this.activeName || "";
      if (paramsTab != tab) {
        this.$router.push({ name: "document-developer", params: { tab } });
      }
    }
  },
  methods: {
    tabChange(tab) {
      this.activeName = tab;
    },
  },
};
</script>

<style lang="scss" scoped>
.styleTab {
  margin-top: 32px;
  border: 1px solid #e0e0e0;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  background: #ffffff;
}
</style>
<style lang="scss">
#documentDeveloperContainer .el-tabs__item {
  height: 52px;
  line-height: 52px;
  width: 150px;
  text-align: center;
}
#documentDeveloperContainer .el-tabs__header {
  margin: 0px;
}
</style>
